/*
  Restock · landing de aceite (sep-2026). Un solo script para toda la página:
  lo cargan las secciones restock-aceite-hero (y restock-grid si lleva etiqueta «Reservado»).
  Todo por delegación de eventos: sobrevive a que el Personalizador vuelva a pintar una sección.

  CONFIGURACIÓN: el JSON [data-rs-config] de la sección «Restock · hero y lista» (producto, fechas,
  Klaviyo, textos de los botones por fase). Sin él, solo funcionan las etiquetas «Reservado»,
  las moléculas, el cuaderno y las apariciones.

  FORMULARIO DE ALTA: embebido en el hero ([data-rs-inline], por defecto) o en ventana ([data-rs-modal]).
  Embebido: los demás botones «Apúntate» (barra fija, CTA final, enlaces #lista) bajan al formulario del hero y lo enfocan.

  ACEITES POR DESVELAR: formularios [data-rs-nl-form] (tarjetas bloqueadas del hub) → newsletter de Klaviyo
  con restock_interes; lista, textos y mensajes en data-attributes que pone restock-grid.

  FASES (hora de Madrid):
  - antes de la apertura → «Apúntate a la lista de espera» → formulario.
  - apertura ≤ ahora < público → con marca localStorage fh_restock_lista=1 (o ?acceso=lista, lo llevan
    los emails) → «Añadir al carrito»; sin marca → «Apúntate y entra ya»: al apuntarse, acceso al instante.
  - ahora ≥ público → carrito para todos. En modo carrito se mira /products/<handle>.js: sin stock → «Agotado».
  - QA: ?rs_preview=antes|abierto|publico fuerza la fase (botones y etiquetas).
  FASES DEL LANZAMIENTO (Configuración del tema → «Restock · fases»): «abre para la lista» y «pasa a BUY» son las
  fechas de arriba; la fase manual manda: BUY = venta para todos; HYPE = nunca pasa a venta para todos.
  ?fase=hype|buy&ver=<producto> las fuerza en el navegador.
*/
(function(){
  if(window.FHRestock)return;
  // Marca de «ya apuntada»: cada campaña la suya (sección «Restock · página única» → «Marca de ya apuntada»)
  var PG=window.FHRestockPagina,PCFG=(PG&&PG.cfg)||{};
  var KEY=PCFG.lsKey||'fh_restock_lista',GRUPOS=PCFG.grupos||['eucalipto','etnalia','aceite2','aceite3'],doc=document,html=doc.documentElement;
  var qs=new URLSearchParams(location.search);
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function lsGet(){try{return localStorage.getItem(KEY)==='1'}catch(e){return false}}
  function lsSet(){try{localStorage.setItem(KEY,'1')}catch(e){}}
  if(qs.get('acceso')==='lista')lsSet();
  var design=!!(window.Shopify&&Shopify.designMode);
  if(!design)html.classList.add('rs-js');

  // «AAAA-MM-DD» + «HH:MM» en hora de Madrid → timestamp (corrige verano/invierno con Intl)
  function madrid(d,h){
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec((d||'').trim()),t=/^(\d{1,2}):(\d{2})$/.exec((h||'00:00').trim());
    if(!m||!t)return Infinity;
    var guess=Date.UTC(+m[1],+m[2]-1,+m[3],+t[1],+t[2]);
    try{
      var parts={};new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Madrid',hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'}).formatToParts(new Date(guess)).forEach(function(x){parts[x.type]=x.value});
      var asUTC=Date.UTC(+parts.year,+parts.month-1,+parts.day,+parts.hour,+parts.minute);
      return guess-(asUTC-guess);
    }catch(e){return guess-2*3600e3}
  }
  function pair(s){s=(s||'').split('|');return madrid(s[0],s[1])}
  // Página única (restock-pagina): solo cuenta lo que está en el grupo visible (o en «siempre»)
  function vis(el){
    if(el.closest&&el.closest('.rs-fase-off'))return false;
    var v=html.getAttribute('data-rs-ver');if(!v)return true;
    // una sección puede llevar un bloque por producto: solo vale el del producto que se está viendo
    var sub=el.closest&&el.closest('[data-rs-prod]');
    if(sub&&sub.getAttribute('data-rs-prod')!==v)return false;
    var sec=el.closest&&el.closest('.shopify-section[data-rs-grupo]');if(!sec)return true;
    var g=sec.getAttribute('data-rs-grupo');return g==='siempre'||g===v;
  }
  function q1(sel){var all=doc.querySelectorAll(sel);for(var i=0;i<all.length;i++){if(vis(all[i]))return all[i]}return null}
  function preview(){var f=qs.get('rs_preview');return f==='antes'||f==='abierto'||f==='publico'?f:null}
  function faseDe(tA,tP,fm,k){
    var f=preview();if(f)return f;
    var pf=qs.get('fase'),pv=qs.get('ver');
    if(pv&&GRUPOS.indexOf(pv)<0)pv=html.getAttribute('data-rs-ver'); // ?ver=mandarina
    if((pf==='hype'||pf==='buy'||pf==='tease')&&(!pv||!k||pv===k))fm=pf==='buy'?'buy':'hype';
    if(fm==='buy')return 'publico';
    var n=Date.now(),r=n>=tP?'publico':n>=tA?'abierto':'antes';
    if(fm==='hype'&&r==='publico')r='abierto';
    return r;
  }

  /* ── CONFIGURACIÓN Y ESTADO DEL CTA ─────────────────────────────────────────────── */
  var D=null,L={},tA=Infinity,tP=Infinity,state='lista',product=null,busy=false,lastFase=null;
  function readConfig(){
    var el=q1('[data-rs-config]'),prevHandle=D&&D.handle;
    if(!el){D=null;return}
    try{D=JSON.parse(el.textContent)}catch(e){D=null;return}
    if(D.handle!==prevHandle){product=null;state='lista'}
    L=D.labels||{};tA=madrid(D.apertura[0],D.apertura[1]);tP=madrid(D.publico[0],D.publico[1]);
  }
  function fase(){return faseDe(tA,tP,D&&D.fm,D&&D.clave)}
  function money(c){try{return new Intl.NumberFormat('es-ES',{style:'currency',currency:D.currency||'EUR'}).format(c/100)}catch(e){return (c/100).toFixed(2).replace('.',',')+' €'}}
  function render(){
    if(!D)return;
    var f=fase();
    doc.querySelectorAll('[data-rs-cta]').forEach(function(b){
      var short=b.hasAttribute('data-short'),txt;
      if(state==='carrito'&&yaEnCarrito()>0){txt=L.carritoAnadido||L.carrito}
      else if(state==='carrito'){txt=L.carrito+(D.precio&&product?' · '+money(product.price):'')}
      else if(state==='agotado'){txt=L.agotado}
      else if(state==='entra'){txt=L.entra}
      else if(state==='apuntada'){txt=L.apuntada}
      else{txt=short?L.listaCorto:L.lista}
      if(b.textContent!==txt)b.textContent=txt||'';
      b.disabled=state==='agotado';
    });
    var subTxt=state==='apuntada'?L.subApuntada:f==='antes'?L.sub:(f==='abierto'&&state!=='entra'?L.subAbierto:(f==='publico'?L.subPublico:L.sub));
    doc.querySelectorAll('[data-rs-sub]').forEach(function(s){s.textContent=subTxt||''});
    doc.querySelectorAll('[data-rs-stickysub]').forEach(function(s){s.textContent=(f==='antes'||state==='entra'?L.stickySub:L.stickySubAbierto)||''});
    renderInline(subTxt);
  }
  // Formulario embebido del hero: qué se ve en cada estado
  function renderInline(subTxt){
    doc.querySelectorAll('[data-rs-inline]').forEach(function(w){
      var wrap=w.querySelector('[data-rs-form-wrap]'),ok=w.querySelector('[data-rs-ok]'),buy=w.querySelector('[data-rs-buy]'),
          submit=w.querySelector('[data-rs-submit]'),legal=w.querySelector('[data-rs-legal]'),okText=w.querySelector('[data-rs-oktext]'),
          sub=w.querySelector('[data-rs-sub]'),otro=w.querySelector('[data-rs-otro]');
      var venta=state==='carrito'||state==='agotado';
      var formOn=state==='lista'||state==='entra'||(state==='apuntada'&&w.dataset.otro==='1');
      var okOn=(state==='apuntada'&&w.dataset.otro!=='1')||(venta&&w.dataset.justOk==='1');
      if(wrap)wrap.hidden=!formOn;
      if(ok)ok.hidden=!okOn;
      if(okText)okText.textContent=(state==='apuntada'?L.okAntes:L.okAbierto)||'';
      if(otro)otro.hidden=state!=='apuntada';
      if(buy)buy.hidden=!venta;
      if(legal)legal.hidden=!formOn;
      if(submit){var t=state==='entra'?L.entra:L.lista;if(submit.textContent!==t&&!submit.disabled)submit.textContent=t||''}
      if(sub)sub.hidden=okOn&&state==='apuntada'||!subTxt;
    });
  }
  function loadProduct(){
    if(product||!D||!D.handle)return Promise.resolve(product);
    return fetch('/products/'+D.handle+'.js').then(function(r){return r.ok?r.json():null}).then(function(j){
      if(!j)return null;
      var v=j.variants.filter(function(x){return x.available})[0]||null;
      product=v?{id:v.id,price:v.price}:{id:null,price:j.price};
      return product;
    }).catch(function(){return null});
  }
  function decide(){
    if(!D)return;
    var f=fase();
    if(f==='antes'){state=lsGet()?'apuntada':'lista';render();return}
    if(f==='abierto'&&!lsGet()){state='entra';render();return}
    loadProduct().then(function(pr){state=pr&&pr.id?'carrito':'agotado';render()});
  }

  /* ── CARRITO ─────────────────────────────────────────────────────────────────────── */
  function addToCart(btn){
    if(busy||!product||!product.id)return;busy=true;
    var prev=btn?btn.textContent:'';if(btn)btn.textContent=L.anadiendo||prev;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:product.id,quantity:1}]})})
      .then(function(r){if(!r.ok)throw 0;return r.json()})
      .then(function(){
        // avisar a la barra de pedido ANTES de refrescar el cajón: si el cajón falla, el estado «añadido» ya está puesto
        if(window.FHRestockPedido&&window.FHRestockPedido.added)window.FHRestockPedido.added(D&&D.clave,D&&D.nombre);
        return window.fhRefreshCart?window.fhRefreshCart():null;
      })
      .then(function(){
        busy=false;if(btn)btn.textContent=prev;
        if(window.FHRestockPedido&&window.FHRestockPedido.added){window.FHRestockPedido.added(D&&D.clave,D&&D.nombre);render();return}
        var d=doc.querySelector('[data-rs-drawer]');if(window.fhRefreshCart&&d){d.click()}else{location.href='/cart'}
      })
      .catch(function(){busy=false;if(btn){btn.textContent=L.error||prev;setTimeout(render,2500)}});
  }

  /* ── VENTANA DE ALTA ─────────────────────────────────────────────────────────────── */
  function modalParts(){
    var m=q1('[data-rs-modal]');if(!m)return null;
    return {m:m,form:m.querySelector('[data-rs-form]'),err:m.querySelector('[data-rs-err]'),wrap:m.querySelector('[data-rs-form-wrap]'),ok:m.querySelector('[data-rs-ok]'),okText:m.querySelector('[data-rs-oktext]'),okBtn:m.querySelector('[data-rs-okbtn]')};
  }
  function openModal(){
    var P=modalParts();if(!P)return;
    if(state==='apuntada'){P.wrap.hidden=true;P.ok.hidden=false;P.okText.textContent=L.okAntes||'';P.okBtn.hidden=true}
    else if(!lsGet()){P.wrap.hidden=false;P.ok.hidden=true}
    if(typeof P.m.showModal==='function'){if(!P.m.open)P.m.showModal()}else{P.m.setAttribute('open','')}
    var i=P.form&&P.form.querySelector('input');if(i&&!P.wrap.hidden)setTimeout(function(){i.focus()},60);
  }
  function closeModal(){var P=modalParts();if(!P)return;if(P.m.close)P.m.close();else P.m.removeAttribute('open')}
  function focusInline(){
    if(!D||!D.inline)return false;
    var w=q1('[data-rs-inline]');if(!w||!w.getClientRects().length)return false;
    var wrap=w.querySelector('[data-rs-form-wrap]'),input=w.querySelector('input[type=email]');
    var y=w.getBoundingClientRect().top+window.pageYOffset-Math.round(window.innerHeight*.28);
    window.scrollTo({top:Math.max(0,y),behavior:reduce?'auto':'smooth'});
    w.classList.remove('is-flash');void w.offsetWidth;w.classList.add('is-flash');
    setTimeout(function(){w.classList.remove('is-flash')},1800);
    if(input&&wrap&&!wrap.hidden)setTimeout(function(){try{input.focus({preventScroll:true})}catch(e){input.focus()}},reduce?0:500);
    return true;
  }
  function act(btn){
    if(!D)return;
    if(state==='carrito')return addToCart(btn);
    if(state==='agotado')return;
    if(focusInline())return;
    openModal();
  }
  // Evento «Lista de espera · alta» (client API): dispara el flow también cuando alguien que ya está en la lista se apunta a otro aceite
  function altaEvento(email,f){
    try{
      fetch('https://a.klaviyo.com/client/events?company_id='+encodeURIComponent(D.key),{method:'POST',headers:{'Content-Type':'application/vnd.api+json',accept:'application/vnd.api+json',revision:'2026-04-15'},
        body:JSON.stringify({data:{type:'event',attributes:{
          properties:{producto:D.interes,fase:f==='antes'?'antes':'abierto',origen:location.origin+location.pathname},
          metric:{data:{type:'metric',attributes:{name:D.evento||'Lista de espera · alta'}}},
          profile:{data:{type:'profile',attributes:{email:email}}}}}})}).catch(function(){});
    }catch(e){}
  }
  function lead(){
    try{if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish)Shopify.analytics.publish('fh_restock_lista',{interes:D.interes})}catch(e){}
    if(!D.pixel)return;
    try{
      if(!window.fbq){!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,doc,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init',D.pixel)}
      fbq('track','Lead',{content_name:(D.leadName||'')+D.interes});
    }catch(e){}
  }
  doc.addEventListener('submit',function(e){
    var form=e.target.closest&&e.target.closest('[data-rs-form]');if(!form||!D)return;
    e.preventDefault();
    var S=form.closest('[data-rs-formscope]')||form.closest('[data-rs-modal]'),inline=!!(S&&S.hasAttribute('data-rs-inline'));
    var P={m:S,form:form,err:S.querySelector('[data-rs-err]'),wrap:S.querySelector('[data-rs-form-wrap]'),ok:S.querySelector('[data-rs-ok]'),okText:S.querySelector('[data-rs-oktext]'),okBtn:S.querySelector('[data-rs-okbtn]')};
    var input=form.querySelector('input[type=email]'),email=(input.value||'').trim(),btn=form.querySelector('[type=submit]');
    P.err.hidden=true;
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){P.err.textContent=L.error||'';P.err.hidden=false;input.focus();return}
    var f=fase(),prev=btn.textContent;btn.disabled=true;btn.textContent=L.enviando||prev;
    var body={data:{type:'subscription',attributes:{custom_source:D.source,profile:{data:{type:'profile',attributes:{
      email:email,
      subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}},
      properties:{restock_interes:D.interes,restock_fase:f==='antes'?'antes':'abierto',restock_origen:location.origin+location.pathname}
    }}}},relationships:{list:{data:{type:'list',id:D.list}}}}};
    fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(D.key),{method:'POST',headers:{'Content-Type':'application/vnd.api+json',accept:'application/vnd.api+json',revision:'2026-04-15'},body:JSON.stringify(body)})
      .then(function(r){if(!r.ok)throw r.status;
        lsSet();lead();altaEvento(email,f);nlInit();
        if(inline){
          delete S.dataset.otro;input.value='';
          if(f==='antes'){decide()}
          else{S.dataset.justOk='1';loadProduct().then(function(pr){state=pr&&pr.id?'carrito':'agotado';render()})}
          var okEl=S.querySelector('[data-rs-ok]');if(okEl)setTimeout(function(){try{okEl.focus&&okEl.setAttribute('tabindex','-1');okEl.focus({preventScroll:true})}catch(x){}},30);
          return;
        }
        P.wrap.hidden=true;P.ok.hidden=false;
        if(f==='antes'){P.okText.textContent=L.okAntes||'';P.okBtn.hidden=true;decide()}
        else{
          P.okText.textContent=L.okAbierto||'';
          loadProduct().then(function(pr){state=pr&&pr.id?'carrito':'agotado';render();P.okBtn.hidden=state!=='carrito';if(state==='carrito')P.okBtn.textContent=L.carrito+(D.precio?' · '+money(pr.price):'')});
        }
      })
      .catch(function(){P.err.textContent=L.error||'';P.err.hidden=false})
      .then(function(){btn.disabled=false;btn.textContent=prev;if(inline)render()});
  });

  /* ── ACEITES POR DESVELAR: newsletter ─────────────────────────────────────────────── */
  function nlKey(i){return 'fh_restock_nl_'+(i||'')}
  function nlInit(){
    doc.querySelectorAll('[data-rs-nl]').forEach(function(box){
      var form=box.querySelector('[data-rs-nl-form]');if(!form)return;
      var done=false;try{done=localStorage.getItem(nlKey(form.dataset.interes))==='1'}catch(e){}
      // formulario general de la campaña (sorteo del hub): comparte la marca con los botones de cada producto
      if(form.dataset.acceso==='1')done=lsGet();
      if(done&&box.dataset.otro!=='1'){form.hidden=true;var ok=box.querySelector('[data-rs-nl-ok]');if(ok)ok.hidden=false;box.classList.add('is-done')}
    });
  }
  doc.addEventListener('submit',function(e){
    var form=e.target.closest&&e.target.closest('[data-rs-nl-form]');if(!form)return;
    e.preventDefault();
    var box=form.closest('[data-rs-nl]'),err=box.querySelector('[data-rs-nl-err]'),ok=box.querySelector('[data-rs-nl-ok]');
    var input=form.querySelector('input[type=email]'),email=(input.value||'').trim(),btn=form.querySelector('[type=submit]'),ds=form.dataset;
    if(err)err.hidden=true;
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){if(err){err.textContent=ds.error||'';err.hidden=false}input.focus();return}
    var prev=btn.textContent;btn.disabled=true;btn.textContent=ds.sending||prev;
    var body={data:{type:'subscription',attributes:{custom_source:ds.source,profile:{data:{type:'profile',attributes:{
      email:email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}},
      properties:{restock_interes:ds.interes,restock_origen:location.origin+location.pathname}
    }}}},relationships:{list:{data:{type:'list',id:ds.list}}}}};
    fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(ds.key),{method:'POST',headers:{'Content-Type':'application/vnd.api+json',accept:'application/vnd.api+json',revision:'2026-04-15'},body:JSON.stringify(body)})
      .then(function(r){if(!r.ok)throw r.status;
        try{localStorage.setItem(nlKey(ds.interes),'1')}catch(x){}
        if(ds.acceso==='1'){
          lsSet();decide();
          try{if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish)Shopify.analytics.publish('fh_restock_lista',{interes:ds.interes})}catch(x){}
          if(ds.pixel){try{
            if(!window.fbq){!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,doc,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init',ds.pixel)}
            fbq('track','Lead',{content_name:(ds.lead||'')+ds.interes});
          }catch(x){}}
        }
        box.classList.add('is-done');
        delete box.dataset.otro;input.value='';form.hidden=true;if(ok){ok.hidden=false;ok.setAttribute('tabindex','-1');try{ok.focus({preventScroll:true})}catch(x){}}
      })
      .catch(function(){if(err){err.textContent=ds.error||'';err.hidden=false}})
      .then(function(){btn.disabled=false;btn.textContent=prev});
  });

  /* ── CLICS (delegación) ──────────────────────────────────────────────────────────── */
  doc.addEventListener('click',function(e){
    var t=e.target;if(!t.closest)return;
    var c=t.closest('[data-rs-cta]');if(c){act(c);return}
    // #lista: tras el posible cambio de producto de la página única (restock-pagina.js), al formulario
    var a=t.closest('a[href="#lista"]');if(a&&(D||html.hasAttribute('data-rs-ver'))){e.preventDefault();setTimeout(function(){act(null)},0);return}
    var ot=t.closest('[data-rs-otro]');
    if(ot){var w=ot.closest('[data-rs-inline]');if(w){w.dataset.otro='1';render();var i=w.querySelector('input[type=email]');if(i)i.focus()}return}
    var no=t.closest('[data-rs-nl-otro]');
    if(no){var bx=no.closest('[data-rs-nl]');if(bx){bx.dataset.otro='1';bx.classList.remove('is-done');var fm=bx.querySelector('[data-rs-nl-form]'),okb=bx.querySelector('[data-rs-nl-ok]');if(okb)okb.hidden=true;if(fm){fm.hidden=false;var ii=fm.querySelector('input');if(ii)ii.focus()}}return}
    var sn=t.closest('[data-rs-story-next]');
    if(sn){
      e.preventDefault();
      var href=sn.getAttribute('href')||'',target=null;
      if(href.length>1&&href.charAt(0)==='#'){try{target=doc.getElementById(decodeURIComponent(href.slice(1)))}catch(x){}if(target&&!target.getClientRects().length)target=null}
      if(!target){var sec=sn.closest('.shopify-section');for(var el=sec&&sec.nextElementSibling;el;el=el.nextElementSibling){if(el.classList&&el.classList.contains('shopify-section')&&el.getClientRects().length&&el.offsetHeight>0){target=el;break}}}
      if(target){var nav=doc.querySelector('.rsn'),off=nav?nav.getBoundingClientRect().height:0;window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top+window.pageYOffset-off),behavior:reduce?'auto':'smooth'})}
      return;
    }
    if(t.closest('[data-rs-close]')){closeModal();return}
    if(t.matches&&t.matches('[data-rs-modal]')){closeModal();return}
    if(t.closest('[data-rs-okbtn]')){closeModal();addToCart(null);return}
    var m=t.closest('.rs-mol');
    if(m){
      var open=!m.classList.contains('is-open'),grid=m.parentNode;
      [].forEach.call(grid.querySelectorAll('.rs-mol'),function(o){o.classList.remove('is-open');o.setAttribute('aria-expanded','false')});
      if(open){m.classList.add('is-open');m.setAttribute('aria-expanded','true')}
      return;
    }
    var lb=t.closest('[data-rs-labbtn]');
    if(lb){
      var lab=doc.getElementById(lb.getAttribute('aria-controls'));if(!lab)return;
      var o=!lab.classList.contains('is-open');
      lab.classList.toggle('is-open',o);lb.setAttribute('aria-expanded',o?'true':'false');
      lb.textContent=o?lb.dataset.closeLabel:lb.dataset.openLabel;
      if(o)setTimeout(function(){lab.scrollIntoView({behavior:'smooth',block:'start'})},250);
    }
  });

  /* ── ETIQUETAS «RESERVADO» (cuenta atrás real) ───────────────────────────────────── */
  function pad(n){return (n<10?'0':'')+n}
  function tickTags(){
    var crossed=false;
    doc.querySelectorAll('[data-rs-tag]').forEach(function(tag){
      var a=pair(tag.dataset.a),p=pair(tag.dataset.p),f=faseDe(a,p,tag.dataset.fm,tag.dataset.k);
      if(tag.dataset.fase&&tag.dataset.fase!==f)crossed=true;
      tag.dataset.fase=f;
      var any=false;
      tag.querySelectorAll('[data-rs-tagstate]').forEach(function(s){var on=s.dataset.rsTagstate===f;s.hidden=!on;if(on)any=true});
      tag.hidden=!any;
      var tm=tag.querySelector('[data-rs-tagstate="'+f+'"] [data-rs-timer]');
      if(!tm)return;
      var target=tm.dataset.rsTimer==='p'?p:a,diff=Math.max(0,Math.floor((target-Date.now())/1000));
      if(preview()&&!isFinite(target))diff=0;
      var d=Math.floor(diff/86400),h=Math.floor(diff%86400/3600),mi=Math.floor(diff%3600/60),se=diff%60;
      var set=function(k,v){var el=tm.querySelector('[data-u="'+k+'"]');if(el&&el.textContent!==v)el.textContent=v};
      set('d',pad(d));set('h',pad(h));set('m',pad(mi));set('s',pad(se));
      var du=tm.querySelector('[data-u="d"]');if(du&&du.parentNode.dataset.hideZero!==undefined)du.parentNode.hidden=d===0;
    });
    return crossed;
  }

  /* ── APARICIONES, BARRA FIJA ─────────────────────────────────────────────────────── */
  var io=null,stickyBound=false,ticking=false;
  function observeReveals(){
    var els=doc.querySelectorAll('.rs-reveal:not([data-rs-seen]),[data-rs-molgrid]:not([data-rs-seen])');
    if(design||!('IntersectionObserver' in window)){els.forEach(function(el){el.classList.add(el.hasAttribute('data-rs-molgrid')?'rs-mol-grid-in':'is-in')});return}
    // si entran varias a la vez (pantalla alta, salto), aparecen una a una con un pequeño escalonado
    if(!io)io=new IntersectionObserver(function(en){var k=0;en.forEach(function(x){if(!x.isIntersecting)return;var t=x.target;
      if(!t.hasAttribute('data-rs-molgrid')){var d=k*110;k++;if(d){t.style.transitionDelay=d+'ms';setTimeout(function(){t.style.transitionDelay=''},d+1000)}}
      t.classList.add(t.hasAttribute('data-rs-molgrid')?'rs-mol-grid-in':'is-in');io.unobserve(t)})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){el.setAttribute('data-rs-seen','');io.observe(el)});
  }
  // barra fija: aparece al pasar el botón del hero y se esconde mientras se ve el CTA final (por scroll: un salto largo no se la salta)
  function updSticky(){
    ticking=false;
    var s=q1('[data-rs-sticky]');
    doc.querySelectorAll('[data-rs-sticky].is-on').forEach(function(o){if(o!==s){o.classList.remove('is-on');o.setAttribute('aria-hidden','true')}});
    if(!s)return;
    var hero=q1('[data-rs-hero] .rs-cta-wrap'),fin=q1('[data-rs-final]'),vh=window.innerHeight;
    var pastHero=hero?hero.getBoundingClientRect().bottom<0:false;
    var finalIn=false;if(fin){var r=fin.getBoundingClientRect();finalIn=r.top<vh*.9&&r.bottom>0}
    var story=false;doc.querySelectorAll('[data-rs-hide-sticky]').forEach(function(x){if(story||!vis(x))return;var rr=x.getBoundingClientRect();if(rr.height>0&&rr.top<vh*.6&&rr.bottom>vh*.4)story=true});
    var on=pastHero&&!finalIn&&!story;
    if(s.classList.contains('is-on')!==on){s.classList.toggle('is-on',on);s.setAttribute('aria-hidden',on?'false':'true');var b=s.querySelector('[data-rs-cta]');if(b)b.tabIndex=on?0:-1}
  }
  function observeSticky(){
    if(!stickyBound){stickyBound=true;var q=function(){if(!ticking){ticking=true;requestAnimationFrame(updSticky)}};window.addEventListener('scroll',q,{passive:true});window.addEventListener('resize',q)}
    updSticky();
  }

  function init(){readConfig();decide();tickTags();observeReveals();observeSticky();nlInit()}
  function yaEnCarrito(){
    var k=D&&D.clave;
    if(!k||!window.FHRestockPedido||!window.FHRestockPedido.qty)return 0;
    try{return window.FHRestockPedido.qty(k)||0}catch(e){return 0}
  }
  doc.addEventListener('rs:carrito',function(){render()});

  window.FHRestock={init:init};
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',init);else init();
  doc.addEventListener('shopify:section:load',init);
  doc.addEventListener('shopify:section:unload',function(){setTimeout(init,0)});
  doc.addEventListener('shopify:section:reorder',init);
  doc.addEventListener('rs:ver',init);
  doc.addEventListener('rs:contenido',function(){observeReveals();tickTags()});
  // cuenta atrás cada segundo; al cruzar una fecha, botones y etiquetas cambian solos
  setInterval(function(){if(tickTags())decide()},1000);
  setInterval(decide,60000);
})();
/* Galería de fotos del hero de cada aceite ([data-rs-gal], snippets/restock-hero-body.liquid). Por delegación:
   sigue funcionando cuando el Personalizador vuelve a pintar la sección. */
(function(){
  if(window.FHRsGal)return;window.FHRsGal=1;
  var doc=document;
  function parts(g){return {t:g.querySelector('[data-rs-gal-track]'),p:g.querySelector('[data-rs-gal-prev]'),n:g.querySelector('[data-rs-gal-next]'),d:g.querySelectorAll('[data-rs-gal-dot]')}}
  function idx(t){return t.clientWidth?Math.round(t.scrollLeft/t.clientWidth):0}
  function sync(g){
    var x=parts(g);if(!x.t)return;
    var i=idx(x.t),max=x.t.children.length-1;
    if(x.p)x.p.disabled=i<=0;if(x.n)x.n.disabled=i>=max;
    for(var k=0;k<x.d.length;k++){if(k===i)x.d[k].setAttribute('aria-current','true');else x.d[k].removeAttribute('aria-current')}
  }
  function go(g,i){var t=parts(g).t;if(!t)return;i=Math.max(0,Math.min(i,t.children.length-1));t.scrollTo({left:i*t.clientWidth})}
  doc.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-rs-gal-prev],[data-rs-gal-next],[data-rs-gal-dot]');if(!b)return;
    var g=b.closest('[data-rs-gal]');if(!g)return;
    var t=parts(g).t,i=idx(t);
    if(b.hasAttribute('data-rs-gal-prev'))go(g,i-1);
    else if(b.hasAttribute('data-rs-gal-next'))go(g,i+1);
    else go(g,+b.getAttribute('data-rs-gal-dot'));
  });
  var raf=0;
  doc.addEventListener('scroll',function(e){
    var t=e.target;if(!t||!t.hasAttribute||!t.hasAttribute('data-rs-gal-track'))return;
    if(raf)cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){sync(t.closest('[data-rs-gal]'))});
  },true);
  doc.addEventListener('keydown',function(e){
    var t=e.target;if(!t||!t.closest)return;var g=t.closest('[data-rs-gal]');if(!g)return;
    if(e.key==='ArrowLeft'){go(g,idx(parts(g).t)-1);e.preventDefault()}else if(e.key==='ArrowRight'){go(g,idx(parts(g).t)+1);e.preventDefault()}
  });
  window.addEventListener('resize',function(){doc.querySelectorAll('[data-rs-gal]').forEach(sync)});
})();
